import React from "react";

export default function VendorNotificationCard({ notification }) {
  const getStatus = (score) => {
    if (score < 60) {
      return {
        text: "Low",
        bg: "bg-red-100",
        color: "text-red-700"
      };
    }

    if (score < 80) {
      return {
        text: "Medium",
        bg: "bg-yellow-100",
        color: "text-yellow-700"
      };
    }

    return {
      text: "Good",
      bg: "bg-green-100",
      color: "text-green-700"
    };
  };

  const ScoreCard = ({ title, score }) => {
    const status = getStatus(Number(score));

    return (
      <div className="border rounded-lg p-3">
        <div className="text-xs text-gray-500">
          {title}
        </div>

        <div className="flex items-center justify-between mt-2">
          <span className="font-bold">
            {Number(score).toFixed(2)}/100
          </span>

          <span
            className={`px-2 py-1 rounded text-[10px] font-semibold ${status.bg} ${status.color}`}
          >
            {status.text}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-xl border shadow-sm p-5 mt-3">

      {/* Header */}

      <div className="flex justify-between items-start">

        <div>

          <h3 className="font-semibold text-slate-800">
            {notification.title}
          </h3>

          <p className="text-sm text-blue-600 mt-1">
            {notification.vendorName}
          </p>

          <p className="text-xs text-gray-500">
            {notification.vendorCategory}
          </p>

        </div>

        <div
          className={`px-3 py-1 rounded-full text-xs font-semibold ${
            notification.riskLevel === "HIGH"
              ? "bg-red-100 text-red-700"
              : notification.riskLevel === "MEDIUM"
              ? "bg-yellow-100 text-yellow-700"
              : "bg-green-100 text-green-700"
          }`}
        >
          {notification.riskLevel}
        </div>

      </div>

      {/* Vendor Rating */}

      <div className="mt-5">

        <div className="text-xs text-gray-500">
          Vendor Rating
        </div>

        <div className="text-2xl font-bold text-blue-600">
          {Number(notification.vendorRating).toFixed(2)}/100
        </div>

      </div>

      {/* Scores */}

      <div className="grid grid-cols-2 gap-3 mt-5">

        <ScoreCard
          title="Delivery"
          score={notification.deliveryScore}
        />

        <ScoreCard
          title="Quality"
          score={notification.qualityScore}
        />

        <ScoreCard
          title="Procurement"
          score={notification.procurementScore}
        />

        <ScoreCard
          title="Financial"
          score={notification.financialScore}
        />

      </div>

      {/* Notification */}

      <div className="mt-5 rounded-lg border bg-gray-50 p-4">

        <div className="text-xs font-semibold text-gray-600 mb-2">
          Vendor Notification
        </div>

        <div className="text-sm text-gray-700 whitespace-pre-line leading-6">
          {notification.message}
        </div>

      </div>

      {/* Button */}

      <div className="mt-5">

        <button
          className="w-full rounded-lg bg-blue-600 py-2 text-white font-medium hover:bg-blue-700"
        >
          View Vendor Details
        </button>

      </div>

    </div>
  );
}

